<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'Multiselect',
  extends: Multiselect,
  methods: {
    pointerForward() {
      this.movePointer(1)
    },
    pointerBackward() {
      this.movePointer(-1)
    },
    movePointer(direction) {
      let index = this.pointer + direction
      while (index >= 0 && index < this.filteredOptions.length) {
        const option = this.filteredOptions[index]
        if (!option?.$isDisabled && (!option?.$isLabel || this.groupSelect)) {
          this.pointerSet(index)
          break
        }
        index += direction
      }
      this.pointerDirty = true
      this.$nextTick(() => this.scrollPointerIntoView())
    },
    scrollPointerIntoView() {
      const list = this.$refs.list
      const option = list?.querySelectorAll('.multiselect__element')[this.pointer]
      if (!this.isOpen || !option) return
      // Measure the rendered cell: options can be grids or rows of varying height.
      const viewportTop = list.getBoundingClientRect().top + list.clientTop
      const bounds = option.getBoundingClientRect()
      if (bounds.top < viewportTop) {
        list.scrollTop += bounds.top - viewportTop
      } else if (bounds.bottom > viewportTop + list.clientHeight) {
        list.scrollTop += bounds.bottom - viewportTop - list.clientHeight
      }
    },
  },
}
</script>
